export default __webpack_public_path__ + "static/media/go.53fc594d.mp3";